module.exports = __webpack_public_path__ + "img/crowd.dbc76ddb.png";